import { getQueryVariable } from './utils/utils';

export default function () {
    const filterGroups = document.querySelectorAll('.gs-filtr-container');
    const pillsContainer = document.getElementById('pills-container');
    const priceFiltering = document.querySelector('.price-filtering');

    if (filterGroups.length === 0) return;

    if (pillsContainer) pillsContainer.innerHTML = '';

    if (priceFiltering) {
        const priceInfo = priceFiltering.querySelector('span');
        const min = priceFiltering.querySelector('#price-filter-handles').getAttribute('data-price-min');
        const max = priceFiltering.querySelector('#price-filter-handles').getAttribute('data-price-max');
        const priceFrom = getQueryVariable('priceFrom') || min;
        const priceTo = getQueryVariable('priceTo') || max;
        const priceGroup = document.createElement('div');

        priceGroup.classList.add('pills-group');
        priceGroup.setAttribute('data-pills-group-name', 'Cena');
        let priceGroupInnerHtml = '';

        if (Number(priceFrom) > min) {
            const priceToElement = `<div class="single-pill" data-pill-price="priceFrom"><span>od <b>${priceFrom} zł</b></span></div>`;
            priceGroupInnerHtml += priceToElement;
        }

        if (Number(priceTo) < max) {
            const priceFromElement = `<div class="single-pill" data-pill-price="priceTo"><span>do <b>${priceTo} zł</b></span></div>`;
            priceGroupInnerHtml += priceFromElement;
        }

        priceGroup.innerHTML = priceGroupInnerHtml;

        if (Number(priceFrom) > min || Number(priceTo) < max) {
            pillsContainer.insertBefore(priceGroup, pillsContainer.firstChild);
            priceInfo.innerText = `od ${priceFrom} do ${priceTo} zł`;
            priceInfo.parentElement.classList.add('any-selected');
        } else {
            priceInfo.parentElement.classList.remove('any-selected');
        }
    }

    filterGroups.forEach(filterGroup => {
        if (filterGroup.classList.contains('price-filtering')) return;

        // :not(:disabled) - skladowe odhaczone przez zaznaczenie calej grupy koloru
        // sa disabled i nie moga tworzyc wlasnych pigulek (pigulke ma sama grupa)
        const selectedParams = filterGroup.querySelectorAll('input[type="checkbox"]:checked:not(:disabled)');
        const filterGroupHeadline = filterGroup.firstElementChild.firstElementChild;

        if (filterGroupHeadline) {
            filterGroupHeadline.innerHTML = '';
        }

        filterGroup.firstElementChild.classList.remove('any-selected');

        if (selectedParams.length === 0) return;

        let selectedParamsString = [...selectedParams]
            .map(param => {
                const label = param.nextElementSibling;
                const text = label.textContent.trim();
                return text || label.getAttribute('title') || '';
            })
            .join(', ');


        if (filterGroupHeadline) {
            filterGroupHeadline.innerHTML = selectedParamsString;
        }

        filterGroup.firstElementChild.classList.add('any-selected');

        const pillsGroup = document.createElement('div');

        pillsGroup.classList.add('pills-group');
        pillsGroup.setAttribute('data-pills-group-name', filterGroup.querySelectorAll('div')[0].getAttribute('data-filter-group'));
        let pillsGroupInnerHtml = '';

        selectedParams.forEach(param => {
            const label = param.nextElementSibling.textContent;
            const text = label ? param.nextElementSibling.getAttribute('title') : label;
            const name = param.getAttribute('id');
            pillsGroupInnerHtml += `<div class="single-pill" data-pill-id="${name}"><span>${text}</span></div>`;

            pillsGroup.innerHTML = pillsGroupInnerHtml;
        });

        pillsContainer.appendChild(pillsGroup);
    });

    if (pillsContainer && pillsContainer.childElementCount > 0 && !pillsContainer.querySelector('button')) {
        const removeButton = document.createElement('span');

        removeButton.classList.add('remove-all-filters');
        removeButton.textContent = 'Wyczyść filtry';
        pillsContainer.prepend(removeButton);
    }

    // licznik na przycisku kanwy filtrow (mobile) i przy czyszczeniu w naglowku kolumny (desktop) -
    // serwer liczy piguly bez ceny, tu juz z cena
    if (pillsContainer) {
        const activeCount = pillsContainer.querySelectorAll('.single-pill').length;

        document.querySelectorAll('.filter-trigger, .filter-top .remove-all-filters').forEach(element => {
            if (activeCount > 0) element.setAttribute('data-count', activeCount);
            else element.removeAttribute('data-count');
        });
    }
}